export const WIDGET_RELATIVE_PATHS = {
    municipal72h: 'municipal72h',
    municipal8d: 'municipal8d',
    mapaPrediccio: 'mapaPrediccio',
    mapaRadar: 'mapaRadar',
    mapaAvisos: 'mapaAvisos',
};

export const WIDGET_NAMES = {
    municipal8d: 'municipal8d',
    municipal72h: 'municipal72h',
    prediccio: 'mapaPrediccio',
    radar: 'mapaRadar',
    avisos: 'mapaAvisos',
};

export const WIDGET_DIMENSIONS = {
    municipal8d: { width: '520', height: '218' },
    municipal72h: { width: '640', height: '350' },
    mapaRadar: { width: '396', height: '412' },
    mapaAvisos: { width: '297', height: '525' },
    mapaPrediccio: { width: '565', height: '388' },
    default: { width: '565', height: '388' },
};

// Padding & margin widgets
export const WIDGETS_PADDING = { padding: '0 10px' };
export const WIDGET_MARGIN_BOTTOM = 20;

export const WIDGET_TYPE = {
    corporate: 'corporate',
    monochrome: 'monochrome',
};

// Data Formats
export const SUFFIXES = {
    speed: {
        knots: 'knots',
        km: 'km/h',
    },
    temperature: {
        celsius: ' ºC',
        fahrenheit: 'ºF',
    },
};

// Config Defaults
export const DEFAULT_CONFIG = {
    alternativeTitle: '',
    city: 'Barcelona',
    widgetType: WIDGET_TYPE.corporate,
    color: '#2c3e50',
    language: 'ca',
    location: '080193',
    tempMaxColor: '#fd8d8a',
    tempMinColor: '#5eb9e2',
    tempFormat: SUFFIXES.temperature.celsius,
    windSpeedFormat: SUFFIXES.speed.km,
    // Municipal72h
    mainChart: 'estCel',
    secondaryChart: true,
    // Header Colors
    headerColor1: '#15468a',
    headerColor3: '#f9ca4e',
    headerColor2: '#00905f',
    // DayNav current color
    dayNavCurrentColor: '#fc706c',
    // Nav target
    target: '_parent',
};

export const MONOCHROME_COLORS = {
    tempMaxAlpha: 0.7,
    tempMinAlpha: 0.45,
};

// Colors in Mapa d'Avisos Widget
export const COLORS_AVISOS = {
    sensePerill: '#b1d330',
    perillModerat: '#ffd738',
    perillAlt: '#ed8426',
    perillMoltAlt: '#e00824',
    seaLayerSensePerill: '#fff',
    borderComarques: '#7f8c1c',
    borderSeaLayerSensePerill: '#b3b3b2',
};

export const PERILL_GRADES = {
    sense: 0,
    moderat: 1,
    alt: 2,
    moltAlt: 3,
};

// Used in radar to check if data is valid
export const MINUTES_FOR_NOT_SHOWING_TILES = 30;

// DataViz
export const GRAPH = {
    height: 121,
};

// Wind speed colors
export const WIND_SPEED_COLORS = {
    0: 'rgb(18,244,244)',
    5: 'rgb(8,159,252)',
    10: 'rgb(14,81,248)',
    20: 'rgb(16,13,112)',
    30: 'rgb(95,255,0)',
    40: 'rgb(1,206,63)',
    50: 'rgb(56,144,0)',
    60: 'rgb(32,95,1)',
    70: 'rgb(255,255,0)',
    80: 'rgb(255,235,0)',
};

// Tendencies correspondencies value <-> icon name
export const TENDENCIES_VALUES = {
    '1': 'Puja',
    '0': 'Mante',
    '-1': 'Baixa',
};

export const CATALUNYA_CENTER = {
    latitude: 41.7,
    longitude: 1.8,
};

export const MAX_BOUNDS = [[43, 3.6], [40.3, 0]];

export const meteorsAvisos = [
    { index: 0, nom: 'Acumulació de pluja' },
    { index: 1, nom: 'Intensitat de pluja en 30 minuts' },
    { index: 2, nom: 'Neu' },
    { index: 3, nom: 'Estat de la mar' },
    { index: 4, nom: 'Calor' },
    { index: 5, nom: 'Fred' },
    { index: 6, nom: 'Vent' },
    { index: 7, nom: 'Temps violent' },
    { index: 8, nom: 'Calor nocturna' },
    { index: 9, nom: 'Intensitat de pluja en 3 hores' },
];

// Other globals
export const NAUTICA_MILE_TO_KMH = 1.852;
export const METRES_TO_KMH = 3.6;
export const HORA_INICI_DIA = 7;
export const HORA_FI_DIA = 21;
export const ALTERNATIVE_TITLE_MAX_LENGTH = 50;


export const TEMPERTURES_COLORS = [
    {
        condicions: [-50, -24],
        colorRGB: [175, 175, 173]
    }, {
        condicions: [-24, -22],
        colorRGB: [127, 128, 126]
    }, {
        condicions: [-22, -20],
        colorRGB: [93, 93, 92]
    }, {
        condicions: [-20, -18],
        colorRGB: [0, 0, 168]
    }, {
        condicions: [-18, -16],
        colorRGB: [66, 22, 202]
    }, {
        condicions: [-16, -14],
        colorRGB: [80, 46, 189]
    }, {
        condicions: [-14, -12],
        colorRGB: [93, 69, 175]
    }, {
        condicions: [-12, -10],
        colorRGB: [110, 94, 160]
    }, {
        condicions: [-10, -8],
        colorRGB: [100, 0, 100]
    }, {
        condicions: [-8, -6],
        colorRGB: [126, 38, 126]
    }, {
        condicions: [-6, -4],
        colorRGB: [155, 79, 155]
    }, {
        condicions: [-4, -2],
        colorRGB: [186, 122, 186]
    }, {
        condicions: [-2, 0],
        colorRGB: [205, 150, 205]
    }, {
        condicions: [0, 2],
        colorRGB: [204, 255, 255]
    }, {
        condicions: [2, 4],
        colorRGB: [164, 236, 239]
    }, {
        condicions: [4, 6],
        colorRGB: [134, 216, 217]
    }, {
        condicions: [6, 8],
        colorRGB: [106, 194, 209]
    }, {
        condicions: [8, 10],
        colorRGB: [65, 157, 171]
    }, {
        condicions: [10, 12],
        colorRGB: [1, 134, 45]
    }, {
        condicions: [12, 14],
        colorRGB: [3, 194, 40]
    }, {
        condicions: [14, 16],
        colorRGB: [0, 255, 64]
    }, {
        condicions: [16, 18],
        colorRGB: [123, 241, 123]
    }, {
        condicions: [18, 20],
        colorRGB: [201, 255, 148]
    }, {
        condicions: [20, 22],
        colorRGB: [241, 242, 136]
    }, {
        condicions: [22, 24],
        colorRGB: [241, 207, 101]
    }, {
        condicions: [24, 26],
        colorRGB: [240, 171, 65]
    }, {
        condicions: [26, 28],
        colorRGB: [240, 138, 31]
    }, {
        condicions: [28, 30],
        colorRGB: [240, 107, 0]
    }, {
        condicions: [30, 32],
        colorRGB: [255, 102, 102]
    }, {
        condicions: [32, 34],
        colorRGB: [255, 70, 70]
    }, {
        condicions: [34, 36],
        colorRGB: [255, 0, 0]
    }, {
        condicions: [36, 38],
        colorRGB: [178, 34, 34]
    }, {
        condicions: [38, 40],
        colorRGB: [155, 0, 0]
    }, {
        condicions: [40, 42],
        colorRGB: [115, 0, 0]
    }, {
        condicions: [42, 44],
        colorRGB: [79, 0, 0]
    }, {
        condicions: [44, 46],
        colorRGB: [0, 0, 0]
    }, {
        condicions: [46, 10000],
        colorRGB: [175, 175, 173]
    }
];

export const RAIN_COLORS = [
    {
        condicions: [0, 0.2],
        colorRGB: [255, 255, 255]
    }, {
        condicions: [0.2, 1],
        colorRGB: [170, 219, 250]
    }, {
        condicions: [1, 5],
        colorRGB: [110, 192, 255]
    }, {
        condicions: [5, 10],
        colorRGB: [66, 170, 255]
    }, {
        condicions: [10, 20],
        colorRGB: [0, 149, 255]
    }, {
        condicions: [20, 30],
        colorRGB: [0, 115, 255]
    }, {
        condicions: [30, 40],
        colorRGB: [0, 76, 255]
    }, {
        condicions: [40, 50],
        colorRGB: [0, 26, 255]
    }, {
        condicions: [50, 75],
        colorRGB: [77, 26, 255]
    }, {
        condicions: [75, 100],
        colorRGB: [122, 0, 245]
    }, {
        condicions: [100, 150],
        colorRGB: [171, 0, 245]
    }, {
        condicions: [150, 200],
        colorRGB: [196, 0, 245]
    }, {
        condicions: [200, 1000],
        colorRGB: [245, 0, 245]
    }
];

//{0 "Tramuntana", 1 "Gregal", 2 "Llevant", 3 "Xaloc", 4 "Migjorn", 5 "Garbí;", 6 "Ponent", 7 "Mestral"};
export const VENT_NOM_POSICIO = [

    {
        condicions: [22.5, 67.5],
        valor: 1
    }, {
        condicions: [67.5, 112.5],
        valor: 2
    }, {
        condicions: [112.5, 157.5],
        valor: 3
    }, {
        condicions: [157.5, 202.5],
        valor: 4
    }, {
        condicions: [202.5, 247.5],
        valor: 5
    }, {
        condicions: [247.5, 292.5],
        valor: 6
    }, {
        condicions: [292.5, 337.5],
        valor: 7
    }
    
];

export const HUMITAT_COLORS = [
    {
        condicions: [0, 5],
        colorRGB: [120, 0, 0]
    }, {
        condicions: [5, 10],
        colorRGB: [153, 0, 0]
    }, {
        condicions: [10, 15],
        colorRGB: [204, 51, 0]
    }, {
        condicions: [15, 20],
        colorRGB: [255, 0, 0]
    }, {
        condicions: [20, 25],
        colorRGB: [255, 102, 102]
    }, {
        condicions: [25, 30],
        colorRGB: [255, 102, 51]
    }, {
        condicions: [30, 35],
        colorRGB: [255, 153, 51]
    }, {
        condicions: [35, 40],
        colorRGB: [255, 204, 0]
    }, {
        condicions: [40, 45],
        colorRGB: [255, 255, 0]
    }, {
        condicions: [45, 50],
        colorRGB: [153, 255, 0]
    }, {
        condicions: [50, 55],
        colorRGB: [0, 255, 0]
    }, {
        condicions: [55, 60],
        colorRGB: [20, 204, 20]
    }, {
        condicions: [60, 65],
        colorRGB: [0, 140, 0]
    }, {
        condicions: [65, 70],
        colorRGB: [0, 255, 200]
    }, {
        condicions: [70, 75],
        colorRGB: [0, 255, 255]
    }, {
        condicions: [75, 80],
        colorRGB: [0, 150, 250]
    }, {
        condicions: [80, 85],
        colorRGB: [0, 80, 255]
    }, {
        condicions: [85, 90],
        colorRGB: [0, 0, 255]
    }, {
        condicions: [90, 95],
        colorRGB: [100, 51, 204]
    }, {
        condicions: [95, 100],
        colorRGB: [153, 0, 153]
    }, {
        condicions: [100, 106],
        colorRGB: [255, 0, 255]
    }
];



// WEBPACK FOOTER //
// ./src/utils/globals.js